import { render } from "./ModalHistoric.vue?vue&type=template&id=abdb4824&ts=true"
import script from "./ModalHistoric.vue?vue&type=script&lang=ts"
export * from "./ModalHistoric.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Projects\\anc-transparencia\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__